<!-- eslint-disable vue/no-v-html -- SVG from country-flag-icons package -->
<template>
  <v-menu bottom>
    <template #activator="{ on, attrs }">
      <v-btn
        color="rgba(0,0,0,0)"
        depressed
        v-bind="attrs"
        v-on="on"
      >
        <span
          class="locale-flag mr-1"
          v-html="getFlagSvg($i18n.locale)"
        />
        <span
          class="text-uppercase text-caption"
          v-text="getShortLabel($i18n.locale)"
        />
        <v-icon right>
          {{ mdiChevronDown }}
        </v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="item in items"
        :key="item"
        @click="onClick(item)"
      >
        <span
          class="locale-flag locale-flag--small mr-2"
          v-html="getFlagSvg(item)"
        />
        <span
          class="text-caption"
          v-text="getLabel(item)"
        />
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mdiChevronDown } from '@mdi/js';
import US from 'country-flag-icons/string/3x2/US';
import IT from 'country-flag-icons/string/3x2/IT';
import { I18N } from '@/constants';

const FLAG_SVGS = Object.freeze({
  US,
  IT,
});

export default {
  name: 'TheLocaleChanger',
  computed: {
    items() {
      return Object.values(I18N.LOCALES);
    },
  },
  created() {
    this.mdiChevronDown = mdiChevronDown;
  },
  methods: {
    getFlagSvg(locale) {
      const code = I18N.COUNTRY_CODES[locale];
      return FLAG_SVGS[code] || '';
    },
    getLabel(locale) {
      return I18N.LABELS[locale];
    },
    getShortLabel(locale) {
      return I18N.SHORT_LABELS[locale];
    },
    onClick(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem(I18N.STORAGE_KEY, this.$i18n.locale);
    },
  },
};
</script>

<style scoped>
.locale-flag {
  display: inline-flex;
  width: 24px;
  height: 16px;
}

.locale-flag--small {
  width: 20px;
  height: 14px;
}

.locale-flag >>> svg {
  width: 100%;
  height: 100%;
  border-radius: 2px;
}
</style>
